import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { Card, Button, Alert, Spinner, Row, Col, Badge } from 'react-bootstrap'
import { useAdminPermission } from 'api/hooks/use-admin-permissions'
import PermissionValuesList from './PermissionValuesList'

const PermissionDetail = () => {
  const { id } = useParams()
  const { data: permission, isLoading, error } = useAdminPermission({ id })

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">Error loading permission: {error.message}</Alert>
  }

  if (!permission) {
    return <Alert variant="warning">Permission not found.</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>{permission.name}</h2>
        <div>
          <Button as={Link} to={`/admin/permissions/${id}/edit`} variant="warning" className="me-2">Edit Permission</Button>
          <Button as={Link} to="/admin/permissions" variant="light-primary">Back to List</Button>
        </div>
      </div>

      <Row>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Header><h5>Basic Information</h5></Card.Header>
            <Card.Body>
              <dl className="row mb-0">
                <dt className="col-sm-5">Name:</dt>
                <dd className="col-sm-7">{permission.name}</dd>
                <dt className="col-sm-5">Category:</dt>
                <dd className="col-sm-7"><code>{permission.category}</code></dd>
                <dt className="col-sm-5">Category Caption:</dt>
                <dd className="col-sm-7">{permission.category_caption || 'N/A'}</dd>
                <dt className="col-sm-5">Permission Variable:</dt>
                <dd className="col-sm-7">
                  {permission.permission_variable_name
                    ? <code>{permission.permission_variable_name}</code>
                    : <span className="text-muted">Unmapped</span>}
                </dd>
                <dt className="col-sm-5">High Risk:</dt>
                <dd className="col-sm-7">
                  {permission.is_high_risk ? <Badge bg="danger">Yes</Badge> : <Badge bg="secondary">No</Badge>}
                </dd>
                <dt className="col-sm-5">Superuser:</dt>
                <dd className="col-sm-7">
                  {permission.is_superuser ? <Badge bg="warning">Yes</Badge> : <Badge bg="secondary">No</Badge>}
                </dd>
              </dl>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Header><h5>Descriptions</h5></Card.Header>
            <Card.Body>
              <h6>Description</h6>
              <p>{permission.description || 'N/A'}</p>
              <h6>Long Description</h6>
              <p>{permission.long_description || 'N/A'}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card>
        <Card.Header><h5>Permission Values</h5></Card.Header>
        <Card.Body>
          <PermissionValuesList permissionId={id} />
        </Card.Body>
      </Card>
    </div>
  )
}

export default PermissionDetail
